import { styled } from '@mui/material/styles';
import { Box, Grid, Paper } from '@mui/material';
import { StyledProps } from '../types/interface';

export const HelpParentContainer = styled(Box)(({ theme }) => ({
  display: 'inline-grid',
  rowGap: '1em',
  padding: '1em',
  [theme.breakpoints.down('sm')]: {
    '@media(max-height: 725px)': {
      '& > div > h1': {
        fontSize: '16px !important',
      },
    },
  },
  [theme.breakpoints.up('sm')]: {
    //everything tablet upwards
    padding: '2em',
    '& > div > h1': {
      fontSize: '30px !important',
    },
  },

  [theme.breakpoints.down('md')]: {},

  [theme.breakpoints.up('md')]: {
    '@media (min-height: 750px)': {},
    [`&::-webkit-scrollbar`]: {},
    '@media (min-resolution: 1.49dppx)': {
      '@media (max-height: 700px)': {},
    },
  },
}));

export const BubbleText = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'isMobile' && prop !== 'isTablet' && prop !== 'isFormOrLandingPage',
})<StyledProps>(({ theme, backgroundColor }) => ({
  backgroundColor: `${backgroundColor}`,
  borderRadius: '8px',
  padding: '15px',

  '& > div': {
    gridTemplateRows: '50px auto',
    minHeight: '50px',
    display: 'inline-grid',
    rowGap: '10px',
  },

  [theme.breakpoints.down('sm')]: {
    '@media (min-height: 1000px)': {},
  },
  [theme.breakpoints.up('sm')]: {
    //everything tablet upwards
    '& > div': {
      gridTemplateRows: '25px auto',
      minHeight: '120px',
    },
  },

  [theme.breakpoints.down('md')]: {},

  [theme.breakpoints.up('md')]: {
    '@media (min-height: 750px)': {},
    [`&::-webkit-scrollbar`]: {},
    '@media (min-resolution: 1.49dppx)': {
      '@media (max-height: 700px)': {},
    },
  },
}));

export const TEMPLATE = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'isMobile' && prop !== 'isTablet' && prop !== 'isFormOrLandingPage',
})<StyledProps>(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    '@media (min-height: 1000px)': {},
  },
  [theme.breakpoints.up('sm')]: {
    //everything tablet upwards
  },

  [theme.breakpoints.down('md')]: {},

  [theme.breakpoints.up('md')]: {
    '@media (min-height: 750px)': {},
    [`&::-webkit-scrollbar`]: {},
    '@media (min-resolution: 1.49dppx)': {
      '@media (max-height: 700px)': {},
    },
  },
}));
